"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = require("react");

var _invariant = _interopRequireDefault(require("invariant"));

var _useOnAuthenticated = _interopRequireDefault(require("@sprinx/react-auth/useOnAuthenticated"));

var _translate = require("@sprinx/translate");

var _useCachedServiceCall3 = _interopRequireDefault(require("../useCachedServiceCall"));

/**
 * Hook vrati `tuple` lokalizovaneho ciselniku, fuknce lokalizovaneho vyhledavani,
 * @param {{ disableOnAuth: boolean, searchField: string }} [options]
 *   - `disableOnAuth` - disabluje standardni spusteni dotazu na API po prihlaseni uzivatele. Default `false`.
 *   - `searchField` - nazev fieldu pro vyhledavani. Default `label`.
 * @param {*} key
 * @param {*} apiCall
 * @param {*} [cacheHook]
 * @param {*} [defaultValue]
 *
 * @returns Tuple `[value: TL[], localizedSearch: (q: string) => Promise<TL[] | string[]>, rawData: TIn[], reloadData: (void | nextValue: T | (prevV: T) => T | (prevV: T, callResult: T) => T) => void]`
 *    , kede:
 *    - `value` - pole lokalizovanych hodnot
 *    - `localizedSearch: (q: string) => TL[] | string[]` - filtracni funkce pro vyhledavani v
 *    - `reloadData` - handler pro update dat. Parametrem muze byt:
 *      - `void` - pro obnoveni dat se zavola API.
 *      - `nextValue: T` - cachovana hodnota se zmeni na `nextValue`.
 *      - `(prevV: T) => T) => void` - update state handler.
 *      - `(prevV: T, callResult: T) => T) => void` - update state handler s apiCall.
 */
function useCodeList(options, key, apiCall, cacheHook, defaultValue) {
  if (typeof options === 'string') {
    defaultValue = cacheHook;
    cacheHook = apiCall;
    apiCall = key;
    key = options;
    options = {};
  }

  var _disableOnAuth$search = (0, _extends2.default)({
    disableOnAuth: false,
    searchField: 'label',
    disableSearchFieldTranslation: false
  }, options),
      disableOnAuth = _disableOnAuth$search.disableOnAuth,
      disableSearchFieldTranslation = _disableOnAuth$search.disableSearchFieldTranslation,
      searchField = _disableOnAuth$search.searchField;

  (0, _invariant.default)(key, "'useCodeList' requires key option.");
  var onAuthenticated = (0, _useOnAuthenticated.default)();

  var _useState = (0, _react.useState)({
    searchable: [],
    loading: true
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      _useState2$ = _useState2[0],
      loading = _useState2$.loading,
      searchable = _useState2$.searchable,
      setSearchable = _useState2[1];

  var _useCachedServiceCall = (0, _useCachedServiceCall3.default)(key, function () {
    return disableOnAuth ? apiCall() : onAuthenticated.then(function () {
      return apiCall();
    });
  }, cacheHook, function (v) {
    return !v || v.length === 0 ? undefined : v;
  }, defaultValue),
      _useCachedServiceCall2 = (0, _slicedToArray2.default)(_useCachedServiceCall, 3),
      data = _useCachedServiceCall2[0],
      loadingData = _useCachedServiceCall2[1],
      reloadData = _useCachedServiceCall2[2];

  function search(q) {
    return (0, _translate.localizedSearch)(searchField, searchable, q);
  }

  (0, _react.useEffect)(function () {
    if (!loadingData) {
      setSearchable({
        searchable: (0, _translate.convertToSearchable)({
          disableSearchFieldTranslation: disableSearchFieldTranslation
        }, data || [], searchField),
        loading: false
      });
    }
  }, [data, loadingData, searchField, disableSearchFieldTranslation]);
  return [searchable, search, data, loading, reloadData];
}

var _default = useCodeList;
exports.default = _default;